import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = { delay: Number };
    
    connect() {
        // Default to 5 seconds if no delay specified
        const delay = this.hasDelayValue ? this.delayValue : 5000;
        
        // Set timeout to hide the element
        this.timeout = setTimeout(() => {
            this.hide();
        }, delay);
    }
    
    disconnect() {
        // Clear timeout if element is removed before timeout
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }
    
    hide() {
        // Fade out animation
        this.element.style.transition = 'opacity 0.3s ease-out';
        this.element.style.opacity = '0';
        
        // Remove element after fade animation
        setTimeout(() => {
            this.element.remove();
        }, 300);
    }
}